export default {
  metadata: {
    name: 'SwadeshDisplayCard'
  },
  hierarchy: {
    container: [
      {
        'image-container': [
          'image',
          {
            'items-container': [
              {
                'top-container': [
                  {
                    'badge-container': ['badge-swadesh_text']
                  },
                  {
                    'close-container': ['close-icon']
                  }
                ]
              },
              {
                'center-container': [
                  {
                    'start-icon-container': ['start-icon']
                  },
                  {
                    'end-icon-container': ['end-icon']
                  }
                ]
              },
              'bottom-container'
            ]
          }
        ]
      },
      {
        'content-container': ['content-slot']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.center}',
      width: '{custom_18}'
    },
    'image-container': {
      'flex-direction': '{flexDirection.stack}'
    },
    image: {
      height: '{size.max}',
      'aspect-ratio': '{aspect_ratio.3.4}',
      'object-position': 'center',
      'object-fit': 'cover'
    },
    'items-container': {
      height: '{size.max}',
      width: '{size.max}',
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.spaceBetween}',
      'align-items': '{alignItems.center}',
      'z-index': 1
    },
    'top-container': {
      show: true,
      width: '{size.max}',
      'padding-top': '{m}',
      'padding-right': '{m}',
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.spaceBetween}'
    },
    'badge-container': {
      hidden: true,
      'padding-top': '{xs}',
      'padding-left': '{s}',
      'padding-bottom': '{xs}',
      'padding-right': '{s}',
      'border-top-right-radius': '{small}',
      'border-bottom-right-radius': '{small}',
      'background-color': '{custom_bg_2}',
      'background-blur': '10'
    },
    'badge-swadesh_text': {
      appearance: 'body_xs_caps',
      color: 'primary_inverse'
    },
    'close-container': {
      hidden: true,
      'background-color': '#1e1e1e33',
      'background-blur': '10',
      'border-radius': '{pill}',
      'padding-top': '{xxs}',
      'padding-left': '{xxs}',
      'padding-bottom': '{xxs}',
      'padding-right': '{xxs}'
    },
    'close-icon': {
      value: 'ic_swadesh_cross_filled',
      size: '{m}',
      color: '{primaryInverse}'
    },
    'center-container': {
      show: true,
      width: '{size.max}',
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.spaceBetween}'
    },
    'start-icon-container': {
      hidden: true
    },
    'start-icon': {
      size: '{m}',
      value: 'ic_swadesh_left_chevron_outlined'
    },
    'end-icon-container': {
      hidden: true
    },
    'end-icon': {
      size: '{m}',
      value: 'ic_swadesh_right_chevron_outlined'
    },
    'bottom-container': {
      show: true,
      height: '{m}',
      width: '{size.max}'
    },
    'content-container': {
      width: '{size.max}'
    }
  },
  variant: {
    size: {
      '4_5': {
        container: {
          'flex-direction': '{flexDirection.stack}',
          'justify-content': '{justifyContent.center}',
          'align-items': '{alignItems.end}'
        },
        image: {
          'aspect-ratio': '{aspect_ratio.4.5}'
        },
        'content-container': {
          'z-index': 1
        }
      },
      '3_2': {
        image: {
          'aspect-ratio': '{aspect_ratio.3.2}'
        }
      },
      '1_1': {
        image: {
          'aspect-ratio': '{aspect_ratio.1.1}'
        }
      }
    },
    _platform: {
      mobile: {
        container: {
          width: '{custom_17}'
        }
      }
    },
    _showBadge: {
      true: {
        'badge-container': {
          hidden: false
        }
      }
    },
    showArrows: {
      true: {
        'start-icon-container': {
          hidden: false
        },
        'end-icon-container': {
          hidden: false
        }
      }
    },
    showClose: {
      true: {
        'close-container': {
          hidden: false
        }
      }
    }
  },
  combination: [
    {
      false: {
        true: {
          'top-container': {
            'justify-content': '{justifyContent.end}'
          },
          'bottom-container': {
            height: '{custom_11}'
          }
        }
      },
      true: {
        false: {
          'bottom-container': {
            height: '{custom_19}'
          }
        },
        true: {
          'bottom-container': {
            height: '{custom_11}'
          }
        }
      }
    },
    {
      '3_4': {
        mobile: {
          container: {
            width: '{custom_18}'
          }
        }
      },
      '4_5': {
        desktop: {
          container: {
            width: '{custom_20}'
          }
        },
        mobile: {
          container: {
            width: '{custom_13}'
          }
        }
      },
      '3_2': {
        desktop: {
          container: {
            width: '{custom_21}'
          }
        },
        mobile: {
          container: {
            width: '{custom_17}'
          }
        }
      },
      '1_1': {
        desktop: {
          container: {
            width: '{custom_22}'
          }
        },
        mobile: {
          container: {
            width: '{custom_17}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['_showBadge', 'showClose'],
    ['size', '_platform']
  ],
  api: {
    config: {
      size: {
        values: ['3_4', '4_5', '3_2', '1_1']
      },
      _platform: {
        values: ['desktop', 'mobile']
      },
      showClose: {
        values: [false, true]
      },
      showArrows: {
        values: [false, true]
      },
      _showBadge: {
        values: [false, true]
      }
    },
    data: {
      image: {
        value: {
          type: 'image',
          name: 'image'
        }
      },
      'badge-swadesh_text': {
        text: {
          type: 'string',
          name: 'badge'
        }
      }
    },
    events: {
      'close-container': {
        onClick: 'onClose'
      },
      'start-icon-container': {
        onClick: 'onLeftArrowClick'
      },
      'end-icon-container': {
        onClick: 'onRightArrowClick'
      }
    },
    children: {
      'content-slot': {
        name: 'children',
        accepts: ['any']
      }
    }
  }
};
